// extracted by mini-css-extract-plugin
module.exports = {"Content":"MarketplaceItemTabs_Content__2EciB","TabHeader":"MarketplaceItemTabs_TabHeader__2PCH4","Icon":"MarketplaceItemTabs_Icon__2GnYj"};